<template>
    <div :class="['upload_img_box', {'upload_img_box2': title }]"> 
            <span v-if="title" class='ml20'>{{ title }}</span>
            <div :class="title && 'flex'">
            <template v-if="isShowImg">
            <slot name="img">
                <img v-if="imageUrl" :src="imageUrl" width="300px" height="190px">
                <div v-else class="no_img_box"></div>
            </slot>
            </template>
            <slot name="add_pic"></slot>
            <slot name="tip"></slot> 
            <a-space :size="10" :class="title && 'btns'">
                <a-upload name="img" ref="upload" :show-upload-list="false" :customRequest="upload" :before-upload="beforeUpload">
                    <slot>
                        <a-button v-if="title && isUploadBtn" class="change_btn">修改</a-button>
                        <a-button v-else-if="isUploadBtn" type="primary">选择文件</a-button> 
                        <img v-else :src="imageUrl || btnDefaultImg" class="pointer" :width="size" :height="size">
                    </slot>
                </a-upload>
                <slot name="btn"> </slot>
            </a-space>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UploadImage',
    model: {
        prop: 'img',
        event: 'change'
    },
    props: {
        img: {
            type: String,
        },
        imgKey: {
            type: String
        },
        maxSize: {
            type: Number,
            default: 1 * 1024 * 1024
        },
        isShowImg: {
            type: Boolean,
            required: false,
            default: true
        },
        isUploadBtn: {
            type: Boolean,
            required: false,
            default: true
        },
        btnDefaultImg: {
            type: String,
            default: require('@/assets/images/basic/img_upload.png')
        },
        size: {
            type: [String,Number],
            required: false,
            default: 110
        },
        title:{
            type: String,
            default:''
        }
    },
    data () {
        return {
            imageUrl: '',
            limitTypes: ['image/jpeg', 'image/gif', 'image/bmp', 'image/png']
        }
    },
    methods: {
        beforeUpload (file) {
            if (!this.limitTypes.includes(file.type)) {
                this.$message.error('上传图片仅支持JPG、GIF、PNG格式')
                return false
            }
            if (this.maxSize < file.size) {
                this.$message.error(`图片大小最大不能超过${this.maxSize / 1024 / 1024}M`)
                return false
            }
            return true
        },
        upload (file) {
            const nanoid = this.$util.getId()
            const { name } = file.file
            const suffix = name.substr(name.indexOf('.'))
            const key = `member/${this.imgKey}/${file.file.uid + nanoid + suffix}`
            this.$util.cosUpload(key, file.file, ({ loaded }) => {
                file.percent = loaded
            }).then(url => {
                this.imageUrl = url
                this.$emit('change', url)
            })
        },
        UseraddUpload() {
           this.$refs.upload.$el.querySelector('input[type="file"]').click();
        }
    },
    watch: {
        img: {
        handler (img) {
            this.imageUrl = img
        },
        immediate: true
        }
    }
}
</script>

<style scoped>
.img_110 {
    width: 110px;
    height: 110px;
}

.img_138 {
    width: 138px;
    height: 138px;
}
.upload_img_box {
    display: flex;
    flex-direction: column;
}

.upload_img_box2{
    flex-direction: row;
}

.no_img_box {
    width: 300px;
    height: 190px;
    border: 1px solid #d9d9d9;
}

.flex{
    margin-left: 18px;
    display: flex;
    position: relative;
}

.change_btn{
    width: 76px;
    height: 30px;
    border-radius: 52px;
    border: 1px solid #333;
    color: #333333;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 13px;
}

.change_btn:hover{
    border-color: unset!important;
    color: unset!important;
}

.btns{
    position: absolute;
    right: -75%;
    top: 10px;
}

.ml20{
    color: #666;
    font-family: PingFang SC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: unset; 
}
</style>



// WEBPACK FOOTER //
// src/components/common/upload/UploadImage.vue